import { ActionTypes } from "./action-types";
import { MutationTypes } from "./mutation-types";
export const actions = {
    [ActionTypes.UPDATE_VERSION]({ commit }, payload) {
        commit(MutationTypes.UPDATE_VERSION, payload);
    },
};
